import { FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX } from 'pages/FundInvestments/common/constants';
import { generateColumnKey, getArrayValue, getNumberValue, getObjectValue, getStringValue } from 'utilities';
import { CreateColumnsParams, FundInvestmentSummaryColumn } from './createColumns.types';

const createColumns = (params: CreateColumnsParams): FundInvestmentSummaryColumn[] => {
  const { fundInvestmentDetails } = params;

  // Capital account date
  const capitalAccountDate = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.capital_account_date,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Commited capital
  const commitedCapital = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.commited_capital,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Invested capital
  const investedCapital = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.invested_capital,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Realized income
  const realizedIncome = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.realized_income,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Unrealized income
  const unrealizedIncome = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.unrealized_income,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Distributions
  const distributions = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.distributions,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Net capital
  const netCapital = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.net_capital,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Market adjustment
  const marketAdjustment = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.market_adjustment,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  // Concluded fair value of net capital
  const concludedFairValueOfNetCapital = getArrayValue(fundInvestmentDetails).reduce((accumulator, current) => {
    const { id, uuid } = getObjectValue(current);

    const columnKey = generateColumnKey({
      id: getNumberValue(id),
      name: getStringValue(uuid),
      prefix: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX,
    });

    return {
      ...accumulator,
      [columnKey]: {
        value: current?.concluded_fair_value_of_net_capital,
      },
    };
  }, {}) as FundInvestmentSummaryColumn;

  const columns = [
    capitalAccountDate,
    commitedCapital,
    investedCapital,
    realizedIncome,
    unrealizedIncome,
    distributions,
    netCapital,
    marketAdjustment,
    concludedFairValueOfNetCapital,
  ];

  return columns;
};

export default createColumns;
